"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.definition = void 0;
var endpoint_definition_details_generator_1 = require("../../../helpers/endpoint.definition.details.generator");
var api_response_def_1 = require("../../../shared/api.response.def");
var form_def_1 = require("../../../shared/form.def");
exports.definition = (0, endpoint_definition_details_generator_1.makeDefinitionFor)('/form/{form_id}.json', {
    description: 'Get information on a single form',
    method: 'get',
    summary: 'Form Information',
    tags: ['Form'],
    params: [
        {
            $ref: '#/components/parameters/ikeDepartmentId'
        },
        {
            $ref: '#/components/parameters/formIdPath'
        }
    ]
}, [
    {
        code: 200,
        description: api_response_def_1.success,
        schema: form_def_1.form
    },
    (0, api_response_def_1.generateValidationError)()
]);
//# sourceMappingURL=form.get.schema.js.map